export default __webpack_public_path__ + "static/media/measureTextMb3.a43a98e5.png";